import React from "react";

const ItemsTable = ({ items }) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-4 sm:p-6 mt-6">
      <h3 className="text-xl font-bold text-gray-800 mb-4">Item Details</h3>
      <div className="overflow-x-auto">
        <table className="table-auto w-full text-left border-collapse">
          <thead className="bg-gray-200">
            <tr>
              <th className="px-4 py-2">Item Name</th>
              <th className="px-4 py-2">Quantity</th>
              <th className="px-4 py-2">Batch No</th>
              <th className="px-4 py-2">Expiry Date</th>
              <th className="px-4 py-2">Unit Price</th>
              <th className="px-4 py-2">Selling Price</th>
              <th className="px-4 py-2">Discount</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => {
              // Format expiry date if available
              const formattedExpiryDate = item.expiry_date
                ? new Date(item.expiry_date).toLocaleDateString()
                : "-";

              // Display discount only if a discount value exists
              const discount =
                item.line_discount_value > 0
                  ? `${item.line_discount_type} (${item.line_discount_value})`
                  : "-";

              return (
                <tr
                  key={index}
                  className="border-t hover:bg-gray-100 transition"
                >
                  <td className="px-4 py-2">{item.items_name}</td>
                  <td className="px-4 py-2">{item.quantity}</td>
                  <td className="px-4 py-2">{item.batch_no}</td>
                  <td className="px-4 py-2">{formattedExpiryDate}</td>
                  <td className="px-4 py-2">{item.unit_price}</td>
                  <td className="px-4 py-2">{item.selling_price}</td>
                  <td className="px-4 py-2">{discount}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ItemsTable;
